import { useRef, useEffect } from "react"
import * as React from "react"
import styled from "styled-components"
import { DetailNavLink } from "../detailPages/DetailNavLink"
import { useLoggedInState } from "../../globalStates/LoggedInUser"
import branding from "../../branding/branding"
import { DesktopVersionContainer } from "../../utils/Device"
import { trackBannerClick } from "../../utils/GTMTracking"

const GuestUserBannerRoot = styled.div`
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    width: 100%;
    height: 50px;
    background: ${branding.guestUserBanner.bannerBgColor};
    color: ${branding.guestUserBanner.bannerFgColor};
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: pre-wrap;
`
const BannerTextDiv = styled.div`
    font-family: ${branding.font1};
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        font-size: 18px;
    }

    .detailNavLink {
        font-size: 18px;
        text-decoration: underline;
    }
`

interface GuestUserBannerProps {
    setRef?: Function
}

const GuestUserBanner: React.FunctionComponent<GuestUserBannerProps> = (props) => {
    const user = useLoggedInState().user()
    const guestBannerRef = useRef<HTMLDivElement>(null)
    const organization = user?.invitingOrganization ? user.invitingOrganization : null

    useEffect(() => {
        if (guestBannerRef && guestBannerRef.current && props.setRef) props.setRef(guestBannerRef)
        // eslint-disable-next-line
    }, [guestBannerRef])

    let bannerText: string | undefined
    if (organization) {
        if (user?.type === "guest") bannerText = branding.topBannerConfig.guest.bannerTextOrga
        else if (user?.type === "attendee") bannerText = branding.topBannerConfig.attendee.bannerTextOrga
        else if (user?.type === "staff") bannerText = branding.topBannerConfig.staff.bannerTextOrga
        else if (user?.type === "speaker") bannerText = branding.topBannerConfig.speaker.bannerTextOrga
        else if (user?.type === "none") bannerText = branding.topBannerConfig.none.bannerTextOrga
    } else {
        if (user?.type === "guest") bannerText = branding.topBannerConfig.guest.bannerTextNoOrganization
        else if (user?.type === "attendee") bannerText = branding.topBannerConfig.attendee.bannerTextNoOrganization
        else if (user?.type === "staff") bannerText = branding.topBannerConfig.staff.bannerTextNoOrganization
        else if (user?.type === "speaker") bannerText = branding.topBannerConfig.speaker.bannerTextNoOrganization
        else if (user?.type === "none") bannerText = branding.topBannerConfig.none.bannerTextNoOrganization
    }

    if (bannerText) {
        return (
            <DesktopVersionContainer>
                <GuestUserBannerRoot className="user-banner-root" ref={guestBannerRef}>
                    <BannerTextDiv>
                        <span>{bannerText}</span>
                        {organization && (
                            <DetailNavLink
                                id={organization.id}
                                name={organization.name}
                                type="organization"
                                source="GUEST"
                                onClick={() => {
                                    trackBannerClick(organization.id, organization.name, "Guest")
                                }}
                            >
                                {organization.name}
                            </DetailNavLink>
                        )}
                    </BannerTextDiv>
                </GuestUserBannerRoot>
            </DesktopVersionContainer>
        )
    }

    return null
}

export default GuestUserBanner
